// MUI
import { Stack, Typography, Link } from "@mui/material";

const LoginFooter = ({ ...props }) => {
	return (
		<Stack direction="column" className={props.className} spacing={1.5} justifyItems="center" alignItems="center">
			<Typography className="text-[12px]/[14.63px] text-gray-light">
				Powered by <Link href="https://dealerat.com/" className="text-gray-light hover:underline no-underline">Dealer Automation Technologies</Link>
			</Typography>
			<Stack direction="row" spacing={2}>
				<Link href="https://dealerat.com/" className="text-gray-light hover:underline no-underline">
					<Typography className="text-[12px]/[14.63px] text-gray-light">Privacy and Legal</Typography>
				</Link>
				<Link href="https://dealerat.com/" className="text-gray-light hover:underline no-underline">
					<Typography className="text-[12px]/[14.63px] text-gray-light">Contact</Typography>
				</Link>
			</Stack>
		</Stack>
	);
};

export default LoginFooter;
